import Invoice from "./invoice/invoice";

const TrainingInvoice = () => {
  return <Invoice eventType="Training" />;
};

export default TrainingInvoice;
